<script setup lang="ts">
import type { Component } from "vue"
import { ServerCrash } from "@lucide/vue"
import { Button } from "@/shared/ui/button"

const props = defineProps<{
  title?: string
  description?: string
  retriable?: boolean
  retryLabel?: string
  onRetry?: () => void
  icon?: Component
}>()
</script>

<template>
  <div class="min-h-dvh grid place-items-center bg-background px-4">
    <div
      class="flex flex-col items-center gap-6 text-center"
      role="alert"
    >
      <component
        :is="props.icon ?? ServerCrash"
        class="size-16 text-muted-foreground"
        aria-hidden="true"
      />

      <div class="flex flex-col gap-2">
        <h1
          v-if="title"
          class="text-2xl font-semibold tracking-tight text-foreground"
        >
          {{ title }}
        </h1>
        <p
          v-if="description"
          class="text-sm text-muted-foreground"
        >
          {{ description }}
        </p>
      </div>

      <Button
        v-if="retriable"
        variant="outline"
        @click="onRetry"
      >
        {{ retryLabel ?? 'Спробувати знову' }}
      </Button>
    </div>
  </div>
</template>
